(function () {
    'use strict';

    angular
        .module('franchisee-portal.services')
        .service('EventService', EventService)

    /** @ngInject */
    function EventService(HttpService) {
        const EventService = {
            getAllByParameters: getAllByParameters,
            getByUrl: getByUrl,
            getCommentsByParameters: getCommentsByParameters,
            postAccessLog: postAccessLog,
            postComment: postComment
        }

        return EventService;

        function getAllByParameters(params, personId) {
            return HttpService.get(`/events/parameters/${personId}`, {
                params
            });
        }

        function getByUrl(url, personId, responsibilityId) {
            return HttpService.get(`/events/${personId}/${responsibilityId}/${url}`)
        }

        function getCommentsByParameters(params) {
            return HttpService.get('/events/comments', {
                params
            });
        }

        function postAccessLog(accessLogData) {
            return HttpService.post('/events/access-log', accessLogData);
        }

        function postComment(commentData) {
            return HttpService.post('/events/comments', commentData);
        }
    }
}());